import React, {ReactElement} from 'react';
import {useTranslation} from 'react-i18next';
import {DeviceType} from '../../../../incase-domain/common/DeviceType.enum';
import {IQuestionElementProps} from '../../../../incase-domain/elements/base/questionElementBase';
import {IElementQuestionYesNo} from '../../../../incase-domain/elements/question/questionYesNo';
import QuestionLayout from '../common/QuestionLayout';
import QuestionAnswer, {AnswerTypes} from '../question/QuestionAnswer';
import {getAnswerStyles} from '../common/getStyles';

function YesNoQuestionElement(props: IQuestionElementProps<IElementQuestionYesNo>): ReactElement {
    const {element, device = DeviceType.DESKTOP} = props;

    const {t} = useTranslation();

    return (
        <QuestionLayout element={element} device={device} showConfirmButton>
            <div className={`c-yesNoQuestion ${device === DeviceType.MOBILE && 'c-yesNoQuestion--mobile'}`}>
                <QuestionAnswer
                    key={`question-answer-${element.id}-${1}`}
                    answer={t(`presEditPage.yes`)}
                    answerType={AnswerTypes.NONE}
                    comment={element.comment.yes}
                    correctColor={element.correctColor}
                    incorrectColor={element.incorrectColor}
                    debatableColor={element.debatableColor}
                    styles={getAnswerStyles(device, element)}
                    onClick={() => undefined}
                />
                <QuestionAnswer
                    key={`question-answer-${element.id}-${0}`}
                    answer={t(`presEditPage.no`)}
                    answerType={AnswerTypes.NONE}
                    comment={element.comment.no}
                    correctColor={element.correctColor}
                    incorrectColor={element.incorrectColor}
                    debatableColor={element.debatableColor}
                    styles={getAnswerStyles(device, element)}
                    onClick={() => undefined}
                />
            </div>
        </QuestionLayout>
    );
}

export default YesNoQuestionElement;
